import { TrashIcon, DocumentIcon } from "@heroicons/react/24/outline";
import { getFileIcon, formatFileSize } from "src/helpers/documentHelper";

export function StorageUploadRow({ doc, onNameChange, handleDelete }) {
  const ext = doc.file.name.split(".").pop();

  return (
    <div className="group mb-2 flex items-center gap-3 rounded-xl border border-gray-100 bg-white p-3 transition-all hover:border-gray-200">
      <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-gray-50 text-gray-500 transition-colors group-hover:bg-blue-50 group-hover:text-blue-600">{getFileIcon(ext) || <DocumentIcon className="h-5 w-5" />}</div>

      <div className="min-w-0 flex-grow">
        <input
          className="w-full border-b border-l-0 border-r-0 border-t-0 border-transparent bg-transparent p-0 pb-0.5 text-sm font-semibold text-gray-800 transition-all duration-300 ease-in-out placeholder:text-gray-400 focus:border-highlightColor focus:ring-0"
          value={doc.name}
          onChange={(e) => onNameChange(e.target.value)}
          spellCheck={false}
          autoComplete="off"
        />

        <div className="mt-0.5 flex items-center gap-2 text-[10px] font-bold uppercase tracking-tight text-gray-400">
          <span className="text-highlightColor">{ext}</span>
          <span>•</span>
          <span>{formatFileSize(doc.file.size)}</span>
        </div>
      </div>

      <button
        onClick={handleDelete}
        className="rounded-lg p-2 text-gray-400 opacity-0 transition-all duration-200 hover:bg-red-50 hover:text-red-500 group-hover:opacity-100">
        <TrashIcon className="h-5 w-5" />
      </button>
    </div>
  );
}
